import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./context/AuthContext";
import {AppProvider} from "./context/AppContext";
import {createTheme, ThemeProvider} from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme({
    components: {
        MuiAlert: {
            styleOverrides: {
                filledSuccess: {
                    backgroundColor: '#01c8aa',
                    '& .MuiAlert-message': {
                        color: '#ffffff',
                    },
                    '& .MuiAlert-icon': {
                        color: '#ffffff',
                    },
                    '& .MuiIconButton-root': {
                        color: '#ffffff',
                    },
                    '& .MuiSvgIcon-root': {
                        fill: '#ffffff',
                    },
                },
                filledError: {
                    backgroundColor: '#e53935',
                    '& .MuiAlert-message': {
                        color: '#ffffff',
                    },
                    '& .MuiAlert-icon': {
                        color: '#ffffff',
                    },
                    '& .MuiIconButton-root': {
                        color: '#ffffff',
                    },
                    '& .MuiSvgIcon-root': {
                        fill: '#ffffff',
                    },
                },
            },
        },
    },
});

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <AppProvider>
                <AuthProvider>
                    <App/>
                </AuthProvider>
            </AppProvider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
